import {
  Box,
  Button,
  Checkbox,
  FormControl,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useFirebase, useFirestore } from 'react-redux-firebase';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../actions';
import { isUndefined } from 'lodash';
import axios from 'axios';

const useStyles = (small) => {
  return makeStyles((theme) => ({
    header: {
      background: theme.palette.black.main,
      height: '75px',
    },
    title: {
      color: theme.palette.white.main,
    },
    checkboxLabel: {
      fontWeight: 'bold',
    },
    mainBtn: {
      width: 'fit-content',
    },
    disableNotifications: {
      color: '#CDBABA',
      fontSize: theme.sizes.sm.t2,
    },
    disableNotificationsLink: {
      color: '#7558D7',
      fontSize: theme.sizes.sm.t1,
      textDecoration: 'underline',
      width: 'fit-content',
      cursor: 'pointer',
      '&:hover': {
        fontSize: 13,
      },
    },
    privacyRow: {
      display: 'flex',
      alignItems: 'flex-start',
      paddingBlock: 16,
      cursor: 'pointer',
    },
    clientName: {
      fontWeight: 'bold',
      fontSize: 18,
      textTransform: 'uppercase',
    },
    privacyPoliciesTitle: {
      marginBottom: 8,
      fontSize: 22,
      fontWeight: 'light',
    },
    privacyPolicies: {
      textAlign: 'justify',
    },
  }));
};

function Privacy() {
  // define styles
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();
  const organization = useSelector((state) => state.app.organization);
  const appDispatch = useDispatch();
  const firestore = useFirestore();
  const firebase = useFirebase();
  const history = useHistory();

  // states
  const [data, setData] = useState({});
  const [phone, setPhone] = useState('');
  // methods
  // effects
  const search = useLocation().search;
  const organizationId = new URLSearchParams(search).get('organizationId');
  const phoneQuery = new URLSearchParams(search).get('phone');
  const projectId = process.env.REACT_APP_PROJECT_ID;

  const handleCheckboxChange = (name) => {
    setData((prevData) => ({
      ...prevData,
      [name]: !prevData[name],
    }));
  };

  useEffect(async () => {
    if (phoneQuery && organizationId) {
      try {
        const token = await firebase.auth().currentUser.getIdToken(true);
        const response = await axios(
          // TODO:
          `https://us-central1-${projectId}.cloudfunctions.net/updateUserConsent`,
          // `http://127.0.0.1:5001/prestobots-stage/us-central1/updateUserConsent`,
          {
            method: 'GET',
            headers: {
              Authorization: `bearer ${token}`,
            },
            params: {
              organizationId,
              phone: phoneQuery,
            },
          },
        );
        if (response.status === 200) {
          // Si el objeto está vacío por deffault dejo todo en true
          if (response.data && Object.keys(response.data).length === 0) {
            setData({
              utility: true,
              marketing: true,
              authentication: true,
            });
          } else {
            setData(response.data);
          }
        }
      } catch (error) {
        appDispatch({
          type: actions.alert,
          alert: {
            snackbarOpen: true,
            snackbarMessage: 'Ocurrio un error al intentar recuperar sus preferencias',
            snackbarSeverity: 'error',
          },
        });
      }
    }
  }, [firestore, phoneQuery, organizationId]);

  const handleSubmit = async (unsubscribe) => {
    try {
      const unsubscribedData = {};
      appDispatch({
        type: actions.changeLoading,
        loading: { loading: true, priority: 1 },
      });

      if (unsubscribe) {
        unsubscribedData.id = `${phoneQuery}-${organizationId}`;
        unsubscribedData.utility = false;
        unsubscribedData.marketing = false;
        unsubscribedData.authentication = false;

        setData(unsubscribedData);
      }
      const token = await firebase.auth().currentUser.getIdToken(true);

      const response = await axios(
        `https://us-central1-${projectId}.cloudfunctions.net/updateUserConsent/update`,
        // `http://127.0.0.1:5001/prestobots-stage/us-central1/updateUserConsent/update`,

        {
          method: 'POST',
          headers: {
            Authorization: `bearer ${token}`,
          },
          data: {
            organizationId: organizationId,
            phone: phoneQuery,
            userConsent: !unsubscribe ? data : unsubscribedData,
          },
        },
      );

      if (response && response.status === 200) {
        appDispatch({
          type: actions.alert,
          alert: {
            snackbarOpen: true,
            snackbarMessage: 'Actualizado exitosamente!',
            snackbarSeverity: 'success',
          },
        });
      }
    } catch (err) {
      appDispatch({
        type: actions.alert,
        alert: {
          snackbarOpen: true,
          snackbarMessage: 'Ocurrio un error al actualizar sus preferencias',
          snackbarSeverity: 'error',
        },
      });
    } finally {
      appDispatch({
        type: actions.changeLoading,
        loading: { loading: false, priority: 1 },
      });
    }
  };

  const changePhone = () => {
    const _phone = phone.indexOf('549') === -1 ? `549${phone}` : phone;
    history.push(`/privacy?phone=${_phone}`);
  };

  return (
    <Box>
      <Box
        className={classes.header}
        display="flex"
        width="100%"
        alignItems="center"
        justifyContent="center"
      >
        <Box mr={2}>
          <img src="/logo512.png" width="50" alt="PrestoBots" />
        </Box>
        <Typography component="h1" variant="h6" noWrap className={classes.title}>
          Prestobots
        </Typography>
      </Box>
      <Box display="flex" maxWidth="700px" mx="auto" flexDirection="column" p={4}>
        <Box mb={2}>
          <Typography className={classes.privacyPoliciesTitle}>Politicas de privacidad</Typography>
          <Typography className={classes.privacyPolicies}>
            Politicas de privacidad Los datos obtenidos por el Asistente virtual de PrestoBots son
            solicitados para una mejor gestión y atención personalizada del usuario. Estos datos
            pueden ser informados por medio del sistema de gestión que utiliza{' '}
            {organization.displayName} y canalizados a través de mensajeros como WhatsApp. Los
            mismos serán guardados bajo la más absoluta confidencialidad y no serán usados para
            fines distintos a los aquí informados.
          </Typography>
        </Box>
        {/* // TODO: VER TAMBIEN EL CASO EN QUE NO TENGA EL ID DE LA ORG QUE HACEMOS ACÁ? UN SELECTOR DE LAS ORGS */}
        {!phoneQuery && (
          <Box>
            <Typography>Ingrese su número de telefono para consultar sus preferencias</Typography>
            <Box my={2}>
              <FormControl>
                <TextField
                  label="Telefono"
                  name="name"
                  required
                  value={phone}
                  onChange={(event) => setPhone(event.target.value)}
                />
              </FormControl>
            </Box>
            <Button
              type="button"
              variant="contained"
              color="primary"
              className={classes.mainBtn}
              onClick={changePhone}
            >
              Aceptar
            </Button>
          </Box>
        )}
        {phoneQuery && (
          <Box>
            <Box className={classes.privacyRow} onClick={() => handleCheckboxChange('utility')}>
              <Checkbox checked={data && !isUndefined(data.utility) ? !!data.utility : true} />
              <Typography>
                <span className={classes.checkboxLabel}>UTILIDAD: </span>
                Las plantillas de utilidad se relacionan con una transacción específica y acordada,
                y permiten realizar una de las siguientes tareas: confirmar, suspender o cambiar una
                transacción o suscripción.
              </Typography>
            </Box>

            <Box className={classes.privacyRow} onClick={() => handleCheckboxChange('marketing')}>
              <Checkbox checked={data && !isUndefined(data.marketing) ? !!data.marketing : true} />
              <Typography>
                <span className={classes.checkboxLabel}>MARKETING: </span>
                Estas plantillas pueden incluir ofertas o promociones, mensajes de bienvenida o
                despedida, actualizaciones, invitaciones o recomendaciones, o solicitudes para
                responder o completar una nueva transacción.{' '}
              </Typography>
            </Box>

            <Box
              className={classes.privacyRow}
              onClick={() => handleCheckboxChange('authentication')}
            >
              <Checkbox
                checked={data && !isUndefined(data.authentication) ? !!data.authentication : true}
              />
              <Typography>
                <span className={classes.checkboxLabel}>AUTENTICACIÓN: </span>
                Las plantillas de autenticación permiten autenticar usuarios con códigos únicos (por
                lo general, códigos alfanuméricos de 4 a 8 dígitos), probablemente en diferentes
                pasos del proceso de inicio de sesión (por ejemplo, en la verificación de la cuenta,
                la recuperación de la cuenta o los desafíos de integridad).
              </Typography>
            </Box>

            <Box mt={1} mb={4}>
              <Typography>Gracias, que tenga buen dia!</Typography>
            </Box>
            <Button
              type="button"
              variant="contained"
              color="primary"
              className={classes.mainBtn}
              onClick={() => handleSubmit(false)}
            >
              Actualizar mis preferencias
            </Button>
            <Box my={4}>
              <Typography className={classes.disableNotifications}>
                ¿No desea recibir mas notificaciones?
              </Typography>
              <Typography
                className={classes.disableNotificationsLink}
                onClick={() => handleSubmit(true)}
              >
                Dejar de recibir notificaciones
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
}

const Props = {};

Privacy.propTypes = Props;

export default Privacy;
